export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_green.2c15c25a.jpg";